import React, { useEffect } from "react";
import Form from "react-bootstrap/Form";
// import {validateField} from '../ReactFormFunctions';

const CheckBox = ({name,props}) => {
    const {
        fieldErrors,
        fieldSettings,
        validateField,
        setVariables,
        variables
    } = props;
    const {label} = fieldSettings;
    const checked = variables[name];
    const field = fieldSettings[name];
    
    // useEffect(() => {if(checked === undefined) setVariables(vars => {return{...vars, [name]: false}})}, [checked, name, setVariables]);

    const handleCheck=(e)=>{
        const {name, checked} = e.target;
        (() => setVariables({...variables,[name]: checked}))();
    };
    
    return (

        <Form.Group size="lg" controlId={name}>
        <Form.Label>{field.label}{field.required? ' * ':' '}</Form.Label>
        { fieldErrors[name]?<small className="text-danger" > - {fieldErrors[name]}</small>:null}
        <Form.Check type="checkbox" 
                    style = {fieldErrors[name] ? {border:"2px solid red", backgroundColor:"rgb(255,200,200)"}:{}}
                    label={label}
                    key={name}
                    checked={checked}
                    value={checked}
                    name={name}
                    onChange={(e) => handleCheck(e)}
                    onBlur={(e) => validateField(e)}
        />
            {field.toolTip?<p><small className="text-secondary" >{field.toolTip}</small></p>:null}
        </Form.Group>
    
 
    )
}

export default CheckBox;

